import React from "react";

var SvgPlaceholder = function SvgPlaceholder(props) {
  return (
    /*#__PURE__*/
    React.createElement("rect", {
      x: 0,
      y: 0,
      width: 20,
      height: 20,
      style: {
        fill: "DeepPink"
      }
    })
  );
};

export default SvgPlaceholder;